import styled from 'styled-components'
import {Label, SearchIcon} from '@modifi/ui'
import {darkGray} from '@modifi/colors'

export const Description = styled.div`
  color: ${darkGray};
  text-align: center;
  line-height: 1.5;
  font-size: 16px;
`

export const StyledLabel = styled(Label)`
  display: inline-block;
  margin-bottom: 8px;
`

export const CompanyLabelWrapper = styled.div`
  display: flex;
  align-items: baseline;
`

export const StyledSearchIcon = styled(SearchIcon)`
  margin-left: 8px;
`
